<template>
  <div>
    <!-- Navigation -->
    <navigation
      @prev="$emit('prev')"
      @next="$emit('next')"
      :activeStepIndex="activeStepIndex"
      :$v="$v"
      :processing-api="processingApi"
    />

    <!-- Form -->
    <div class="form-group">
      <label class="black title-bold" for="password">
        SENHA:
      </label>
      <div class="error mt-n2" v-if="$v.localPassword.$error">
        <span class="error" v-if="!$v.localPassword.required">{{$t('password') + $t('is_required')}}</span>
        <span class="error" v-else-if="!$v.localPassword.minLength">{{ $t('must_include_length') }}</span>
        <span class="error" v-else-if="!$v.localPassword.containsSpecialCharacters">{{ $t('must_include_special') }}</span>
        <span class="error" v-else-if="!$v.localPassword.containsNumbers">{{ $t('must_include_number') }}</span>
      </div>
      <!-- Password Input -->
      <div class="position-relative">
        <input
          :type="showPassword ? 'text' : 'password'"
          class="form-control"
          id="password"
          :placeholder= "$t('type_password_here')"
          v-model="localPassword"
          @keydown.enter="focusOn('passwordConfirmation')"
          @blur="$v.localPassword.$touch()"
        >
        <span class="input-show-pass pt-2 mr-4" @click="showPassword = !showPassword">
          <i class="fa fa-eye" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'"/>
        </span>
      </div>

      <label class="black title-bold" for="passwordConfirmation">{{ $t('confirm_password_field')}}</label>
      <div class="error mt-n2" v-if="$v.localPasswordConfirm.$error">
        <span class="error" v-if="!$v.localPasswordConfirm.sameAsLocalPassword">{{ $t('enter_same_password') }}</span>
      </div>
      <!-- Confirm Password Input -->
      <div class="position-relative">
        <input
          :type="showPassword ? 'text' : 'password'"
          class="form-control"
          id="passwordConfirmation"
          placeholder="Confirme aqui"
          v-model="localPasswordConfirm"
          @keyup.enter="goToNextStep"
          @blur="$v.localPasswordConfirm.$touch()"
          onpaste="return false;"
        />

        <span class="input-show-pass pt-2 mr-4" @click="showPassword = !showPassword">
          <i class="fa fa-eye" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'"/>
        </span>
      </div>
    </div>

    <p class="pl-3">
      <small>{{ $t('at_least_length') }}</small><br>
      <small>{{ $t('at_least_special') }}</small><br>
      <small>{{ $t('at_least_number') }}</small>
    </p>

    <!-- Button -->
    <section class="row">
      <div class="col-12 mt-5 mx-auto col-md-6">
        <button
          :style="
            style.surveyBtnColor
              ? { backgroundColor: style.surveyBtnColor }
              : { backgroundColor: style.homeBtnColor }
          "
          type="submit"
          class="w-100 btn btn-primary btn-block my-3"
          @click="goToNextStep"
          :disabled="$v.$invalid"
        >
          {{ $t('advance') }}
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            v-if="processingApi"
          ></span>
        </button>
      </div>
    </section>

  </div>
</template>

<script>
import {sameAs, minLength, required} from 'vuelidate/lib/validators'
import Navigation from "@/components/registration/components/Navigation";

const containsSpecialCharacters = (str) => {
  // eslint-disable-next-line no-useless-escape
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

  return specialChars.test(str);
}
const containsNumbers = (str) => {
  return /[0-9]/.test(str);
}

export default {
  name: "Password",
  components: {Navigation},
  props: {
    profile: {
      type: Object,
      required: true
    },
    processingApi: {
      type: Boolean,
      required: true
    },
    activeStepIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      localPassword: '',
      localPasswordConfirm: '',
      showPassword: false,
    }
  },
  computed: {
    style() {
      return this.$store.state.template.style;
    },
  },
  validations: {
    localPassword: {
      required,
      minLength: minLength(6),
      containsSpecialCharacters,
      containsNumbers,
    },
    localPasswordConfirm: {
      sameAsLocalPassword: sameAs('localPassword')
    }
  },
  watch: {
    localPassword () {
      this.profile.Password = this.localPassword
    }
  },
  mounted() {
    this.focusOn('password')
  },
  methods: {
    focusOn(el) {
      document.getElementById(el).focus();
    },
    goToNextStep() {
      if (!this.$v.$invalid) this.$emit('next')
    }
  }
}
</script>

<style>
.input-show-pass {
  font-size: 20px;
  color: #212529;
  display: flex;
  position: absolute;
  height: 100%;
  top: 0;
  right: 12px;
  padding: 0 5px;
  cursor: pointer;
  transition: background 0.4s;
}

.input-show-pass:hover {
  color: #a09569;
}
</style>
